import "./App.css";
import Homepage from "./pages/Homepage";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./styles/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EntryPage from "./pages/EntryPage";
import { useEffect } from "react";
import RegisterUser from "./pages/RegisterUser";
import UserListPage from "./pages/UserListPage";
import AddDepartment from "./pages/AddDepartment";
import DepartmentListPage from "./pages/DepartmentListPage";
import LoginPage from "./pages/LoginPage";
import ManufacturerPage from "./pages/ManufacturerPage";
import ModelMasterPage from "./pages/ModelMasterPage";
import DeviceTypeMasterPage from "./pages/DeviceTypeMasterPage";
import NotFound from "./pages/NotFound";
import useAuth, { Authentication } from "./useAuth";
import AuthorizationCheck from "./Components/AuthorizationCheck";
import { ProfilePage } from "./pages/ProfilePage";
import Devices from "./pages/Devices";
import DeviceLogs from "./pages/DeviceLogs";
import NetworkScan from "./pages/NetworkScan";
import PingDevice from "./pages/PingDevice";
import Reports from "./pages/Reports";
import AddStock from "./pages/AddStock";
import StockListPage from "./pages/StockListPage";
import RegisteredWifiUsers from "./pages/RegisteredWifiUsers";

function App() {
  const Scroll = (props) => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    return props.children;
  };

  const { user } = useAuth();
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" />
      <Authentication>
        <Scroll>
          <Routes>
            <Route path="login" element={<LoginPage />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/" element={<Navigate to="/my" />} />
            <Route path="/my" element={<EntryPage />}>
              <Route path="" element={<Navigate to="home" />} />

              {/* <Route path="home" element={<Homepage />} /> */}
              <Route path="home" element={<Navigate to="../devices" />} />
              <Route
                path="users"
                element={
                  <AuthorizationCheck restrictedRoles={["others"]}>
                    <UserListPage />
                  </AuthorizationCheck>
                }
              />
              <Route
                path="registerUser"
                element={
                  <AuthorizationCheck restrictedRoles={["others"]}>
                    <RegisterUser />
                  </AuthorizationCheck>
                }
              />
              <Route
                path="registered-wifi-users"
                element={
                  <AuthorizationCheck restrictedRoles={["others"]}>
                    <RegisteredWifiUsers />
                  </AuthorizationCheck>
                }
              />
              <Route
                path="departments"
                element={
                  <AuthorizationCheck restrictedRoles={["others"]}>
                    <DepartmentListPage />
                  </AuthorizationCheck>
                }
              />
              <Route
                path="addDepartment"
                element={
                  <AuthorizationCheck restrictedRoles={["others"]}>
                    <AddDepartment />
                  </AuthorizationCheck>
                }
              />

              <Route path="profile" element={<ProfilePage />} />

              <Route path="devices" element={<Devices />} />
              <Route path="device-logs" element={<DeviceLogs />} />
              <Route path="network-scan" element={<NetworkScan />} />
              <Route path="ping-device" element={<PingDevice />} />
              <Route
                path="reports"
                element={
                  <AuthorizationCheck restrictedRoles={["others"]}>
                    <Reports />
                  </AuthorizationCheck>
                }
              />
              <Route
                path="add-stock"
                element={
                  <AuthorizationCheck restrictedRoles={["others"]}>
                    <AddStock />
                  </AuthorizationCheck>
                }
              />
              <Route
                path="stocks"
                element={
                  <AuthorizationCheck restrictedRoles={["others"]}>
                    <StockListPage />
                  </AuthorizationCheck>
                }
              />
              <Route
                path="manufacturers"
                element={
                  <AuthorizationCheck restrictedRoles={["others"]}>
                    <ManufacturerPage />
                  </AuthorizationCheck>
                }
              />
              <Route
                path="models"
                element={
                  <AuthorizationCheck restrictedRoles={["others"]}>
                    <ModelMasterPage />
                  </AuthorizationCheck>
                }
              />
              <Route
                path="device-types"
                element={
                  <AuthorizationCheck restrictedRoles={["others"]}>
                    <DeviceTypeMasterPage />
                  </AuthorizationCheck>
                }
              />
            </Route>
          </Routes>
        </Scroll>
      </Authentication>
    </BrowserRouter>
  );
}

export default App;
